<template>
    <span>
        <r-button @click="openModal" fluid>
            <span>{{btnLabel}}</span>
        </r-button>
        <reactivate-modal
            :order="order"
            v-if="isReactivating"
            @close="isReactivating = false"/>
        <cancel-modal
            :order="order"
            v-if="isCancelling"
            @close="isCancelling = false"/>
    </span>
</template>

<script>
    import ReactivateModal from './reactivate-modal';
    import CancelModal from './cancel-modal';

    export default {
        name: 'cancel-reactivate-order',
        components: {ReactivateModal, CancelModal},
        props: {
            order: Object,
        },
        computed: {
            btnLabel() {
                return this.isCancellable ? 'Cancel Order' : 'Reactivate Order';
            },
            isCancellable() {
                return !this.order.isCanceled;
            },
        },
        data() {
            return {
                isCancelling: false,
                isReactivating: false,
            };
        },
        methods: {
            openModal() {
                if (this.isCancellable) {
                    this.isCancelling = true;
                } else {
                    this.isReactivating = true;
                }
            },
        },
    };
</script>
